/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiffusionListPaged } from '../../models/diffusion-list-paged';
import { DiffusionListSortFieldName } from '../../models/diffusion-list-sort-field-name';
import { SortDirection } from '../../models/sort-direction';

export interface SearchDiffusionLists$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the diffusion list's name
 */
  sortFieldName?: DiffusionListSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search diffusion lists
     */
    body?: any
}

export function searchDiffusionLists$Any(http: HttpClient, rootUrl: string, params?: SearchDiffusionLists$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<DiffusionListPaged>> {
  const rb = new RequestBuilder(rootUrl, searchDiffusionLists$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiffusionListPaged>;
    })
  );
}

searchDiffusionLists$Any.PATH = '/users/diffusionlist/search';
